module.exports = __webpack_public_path__ + "static/media/icon-select-orange.0af97727.svg";